import React from 'react';
import { Rocket, Smartphone, Cloud, Palette } from 'lucide-react';
import './CapabilityCards.css';

const capabilities = [
  {
    icon: <Rocket size={40} />,
    title: 'Build Scalable Web Applications',
    description: 'Enterprise-grade web apps that handle millions of users with blazing fast performance.'
  },
  {
    icon: <Smartphone size={40} />,
    title: 'Develop High-Performance Mobile Apps',
    description: 'Native and cross-platform mobile experiences that users love and keep coming back to.'
  },
  {
    icon: <Cloud size={40} />,
    title: 'Cloud & Backend Solutions',
    description: 'Scalable, secure, and cost-effective cloud infrastructure for your business needs.'
  },
  {
    icon: <Palette size={40} />,
    title: 'UI/UX That Converts Users',
    description: 'Beautiful, intuitive interfaces designed to maximize engagement and conversion rates.'
  }
];

const CapabilityCards = () => {
  return (
    <section className="capability-cards section">
      <div className="container">
        <h2 className="section-title">What We <span className="black-text">Build</span></h2>
        <p className="section-subtitle">
          Real solutions that deliver real results for your business
        </p>

        <div className="capability-grid">
          {capabilities.map((capability, index) => (
            <div key={index} className="capability-card">
              <div className="capability-icon">{capability.icon}</div>
              <h3>{capability.title}</h3>
              <p>{capability.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CapabilityCards;